<template lang="html">

    <!-- white area -->
    <div class="px-3 py-3 w-100">

        <div class="row">

            <div class="col-sm-12 text-center">
                <h1>Task history</h1>
            </div>

            <div class="col-sm-12 bg-lightest">

                <!-- Table -->
                <div v-if="isLoadingHistoric" class="p-4 text-center mb-4 w-100">
                    <loader></loader>
                </div>

                <div v-else-if="tableRows.length == 0" class="text-center dark p-4 my-2 w-100">
                    <span class="">This task has no historic.</span>
                </div>

                <div v-else>
                    <!-- Pagination -->
                    <div class="d-flex justify-content-end my-2 w-100">
                        <uib-pagination v-if="currentPagination.numPages > 1" v-model="currentPagination" :total-items="paginationSettings.totalItems" :items-per-page="paginationSettings.itemsPerPage" :boundary-link-numbers="false" :max-size="7" @change="fetchTaskHistoric"></uib-pagination>
                    </div>

                    <!-- Content list -->
                    <list :header="header" :body="body" :rows="tableRows" :actions="actions" :showNoDataMessage="false"></list>

                    <!-- Pagination -->
                    <div class="d-flex justify-content-end my-2">
                        <uib-pagination v-if="currentPagination.numPages > 1" v-model="currentPagination" :total-items="paginationSettings.totalItems" :items-per-page="paginationSettings.itemsPerPage" :boundary-link-numbers="false" :max-size="7" @change="fetchTaskHistoric"></uib-pagination>
                    </div>
                </div>

            </div>
        </div>
    </div>

</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import Loader from '@/tools/loaders/loader1'
import List from '@/tools/list/baseList'

import taskResultLabel from './taskResultLabel'

export default {
    created: function () {
        this.fetchTaskHistoric()
    },
    data: function () {
        return {
            isLoadingHistoric: false,
            currentPagination: {
                currentPage: 1,
                numPages:1
            },
            paginationSettings: {
                itemsPerPage: 25,
                totalItems: 0
            },
            tableRows: [
                // {
                //     id: 44,
                //     name: 'Dummy temp dev task',
                //     taskType: 10000,
                //     lastExecutionDate: '2020-02-10 18:11:00',
                //     nextExecutionDate: '2020-02-10 20:11:00',
                //     isRunning: false,
                //     isFinished: true,
                // }
            ],
            actions: {
                label : 'Actions',
                alwaysVisible: true,
                list: [
                    {
                        slug: 'history',
                        title: 'History',
                        tooltip: 'Replay this task',
                        params: '',
                        class: '',
                        icon: 'fas fa-reply largest',
                        event: this.replayTask
                    },
                ],
            }
        }
    },
    computed: {
        ...mapGetters([
            'getSelectedScheduledTask',
            'getTaskExecutionResult',
            'getTaskProcessType'
        ]),
        header: function () {
            let vm = this
            return {
                selection: {
                    active: false,
                    event: function(event) {}
                },
                list: {
                    name: 'Name',
                    periodStart: 'Period Start',
                    periodEnd: 'Period End',
                    executionDate: 'Execution Date',
                    isFinished: 'Has finished',
                    isManual: 'Process Type',
                    result: 'Result'
                },
                customClassCell:{
                    status: 'scheduleTaskListStatus text-center',
                    type: 'scheduleTaskListType',
                    repetition: 'scheduleTaskListRepetition',
                    // products: 'w-50',
                }
            };
        },
        body: function() {
            let vm = this;

            return {
                selection: {
                    active: false,
                    event: function(event, row) {}
                },
                customRowEvent: function(row) {},
                customCells: {
                    name: (row) => {
                        return row.name
                    },
                    periodStart: (row) => {
                        return row.periodStart? row.periodStart : ' - '
                    },
                    periodEnd: (row) => {
                        return row.periodEnd? row.periodEnd : ' - '
                    },
                    executionDate: (row) => {
                        return row.nextExecutionDate? row.nextExecutionDate : ' - '
                    },
                    isFinished: (row) => {
                        return row.isFinished == true? 'Yes':'No'
                    },
                    isManual: (row) => {
                        return this.decodeIsManual(row)
                    },
                    result: (row) => {
                        // if error (-1) show toltip with error here
                        // return this.decodeResult(row)
                        return {
                            component: taskResultLabel,
                            arguments: row
                        }

                    },
                },
                customClassCell: {
                    name: '',
                    periodStart: '',
                    periodEnd: '',
                    executionDate: '',
                    isFinished: '',
                    isManual: '',
                    result: 'pointer',
                },
            }
        },
    },
    methods: {
        ...mapActions([
            'getScheduleTaskHistory',
            'replayScheduleTask'
        ]),
        fetchTaskHistoric: function () {
            this.isLoadingHistoric = true
            this.getScheduleTaskHistory({
                pagination: this.currentPagination,
                paginationSettings: this.paginationSettings,
                scheduleTask: this.getSelectedScheduledTask,
            }).then(response => {
                this.isLoadingHistoric = false
                this.tableRows = response.data.result
                this.paginationSettings.totalItems = response.data.pageInfo.totalItemCount
                this.currentPagination.numPages = response.data.pageInfo.pageCount
            })
        },
        decodeIsManual: function (task) {
            let foundIsManual = this.getTaskProcessType.find(processType => {
                return processType.id == task.taskProcessType
            })

            if(foundIsManual){
                return foundIsManual.label
            } else {
                return ' - '
            }
        },
        decodeResult: function (task) {
            let foundResult = this.getTaskExecutionResult.find(storedResult => {
                return storedResult.id == task.taskExecutionResult
            })

            if(foundResult){
                return `<div><span class="px-2 py-0 radius-normal fs-smaller bold bg-${foundResult.color1} ${foundResult.color2}">${foundResult.label}</span></div>`
            } else {
                return '-'
            }
        },
        replayTask: function (scheduleTask) {
            console.log('replayTask', scheduleTask);
            this.$dialog.confirm('\
            <div class="fs-larg font-weight-600 mb-4">Replay this schedule task?</div>\
            <div>This task will run again, are you sure?</div>')
            .then(() => {
                this.replayScheduleTask(scheduleTask).then(response => {
                    this.fetchTaskHistoric()
                })
            }).catch(function () {

            });
        }
    },
    components: {
        Loader,
        List,
        taskResultLabel
    }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// taskHistoric.vue?42e392c6